import React, { Component } from 'react';

import './barchart.scss';
import TouchIcon from '../../public/assets/images/touch.svg';

const assetsContext = require.context('../../public/assets/images/', false, /\.svg$/)

export default class BarChart extends Component {

  createBarchartData(data){
    const total = data[16];
    const devices = this.props.data.columns;

    let newData = Object.assign(devices.map( d => {
        return  {
          d : +total[d],
          type: d
        }
      }
    ));

    newData = newData.sort(function(a, b){
      return b.d - a.d;
    });

    return newData;
  }

  render() {
    const barChartData = this.createBarchartData(this.props.data);

    const items = barChartData.map((d, i) => {

      if (d.type === 'Typ') return null;

      const activeClass = this.props.selectedDevice === d.type ? 'active': '';

      return (
          <div className={`barchart--item--wrapper ${activeClass}`} key={`barchart--item${i}`} onClick={() => this.props.handler(d.type)}>
            <div className={`item--icon ${activeClass}`} key={`barchart_item__${i}`} >
              <img className='icon' src={assetsContext(`./${d.type}.svg`)} alt={d.type} />
            </div>
            <div className='bar-wrapper'>
              <div className='bar--top'>
                <div className='item--bar' style={{width: `${d.d}%`}}></div>
                <div className='item--value'>{d.d.toLocaleString('de-DE')}%</div>
              </div>
              <div className='item--type'>{d.type}</div>
            </div>
          </div>
      )
    })

    return (
      <div className="bkr--barchart--wrapper">
        <span className="bkr--barchart--info-icon"><img className='icon' src={TouchIcon} alt='touch icon'/></span>
        <div className="bkr--barchart--info">{window.config.labels.device_info}</div>
        <div className="bkr--barchart">
          {items}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Component/Barchart/index.js